import { h } from 'preact'

export function Loading() {
  return (
    <div
      class="bg-white border border-grey-light flex items-center px-4 xs:px-6 mt-3"
      style={{ height: 65 }}
    >
      Loading...
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/js/widget/Loading.js